// extracted by css-extract-rspack-plugin
export default {"orderConfirm":"orderConfirm-CAACuV","orderConfirmButtons":"orderConfirmButtons-uaVPSc","orderConfirmLink":"orderConfirmLink-NQoAG4","kid":"kid-U1i2VK"};